import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/coqui-ai.github.io/coqui-ai.github.io/src/templates/NewsletterTemplate.tsx";
import { graphql } from 'gatsby';
export const pageQuery = graphql`
  query($fileAbsolutePath: String) {
    ...SidebarPageFragment
  }
`;
export const _frontmatter = {};
const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "934px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "27.599999999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAA3XAAAN1wFCKJt4AAABCElEQVQY042RQUsCcRDF/VB9g+59gk6eOhTRpaBbh5CgYCuiTkYGah6CSIwiyiRbiiyVFg+5EoS6LO1/XS0oXffXriC1atCDOcyDeW/mTQAXjuMwhFHcH/g9H/CaPqG/W5T0V1ShUTbqjDIb7L/abR/vE8y8KEjyMfv5NHuFS87kO0LhCBvxBOuxBPHTc0K7EVJZGV2YhI+SZAvF3qzd7f4I9h287WpNgfho8WzWWdjaZnFzh+DSMtMra0zMzTO7KjE2GewJj0/NcOKKe+jY9vCGWsvkvlom55ZqamhvBqnrG26fFDIPeYTVRIoecHiR5ir3iKJWMBqW/+TBbDynz46by/9/4sv1G2shujMHTg19AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "IMAGE",
          "title": "IMAGE",
          "src": "/static/c9103bc33c8add5ab1fa4fa1c49c90ef/ca463/logo-wordmark.png",
          "srcSet": ["/static/c9103bc33c8add5ab1fa4fa1c49c90ef/43fa5/logo-wordmark.png 250w", "/static/c9103bc33c8add5ab1fa4fa1c49c90ef/c6e3d/logo-wordmark.png 500w", "/static/c9103bc33c8add5ab1fa4fa1c49c90ef/ca463/logo-wordmark.png 934w"],
          "sizes": "(max-width: 934px) 100vw, 934px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <h3 {...{
      "id": "pẹlẹ-o-",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#p%E1%BA%B9l%E1%BA%B9-o-",
        "aria-label": "pẹlẹ o  permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "16",
          "height": "16",
          "focusable": "false",
          "viewBox": "0 0 16 16"
        }}>{`
  `}<path parentName="svg" {...{
            "fill": "currentColor",
            "d": "M4.441 7.38l.095.083.939.939-.708.707-.939-.939-2 2-.132.142a2.829 2.829 0 003.99 3.99l.142-.132 2-2-.939-.939.707-.708.94.94a1 1 0 01.083 1.32l-.083.094-2 2A3.828 3.828 0 01.972 9.621l.15-.158 2-2A1 1 0 014.34 7.31l.101.07zm7.413-3.234a.5.5 0 01.057.638l-.057.07-7 7a.5.5 0 01-.765-.638l.057-.07 7-7a.5.5 0 01.708 0zm3.023-3.025a3.829 3.829 0 01.15 5.257l-.15.158-2 2a1 1 0 01-1.32.083l-.094-.083-.94-.94.708-.707.939.94 2-2 .132-.142a2.829 2.829 0 00-3.99-3.99l-.142.131-2 2 .939.939-.707.708-.94-.94a1 1 0 01-.082-1.32l.083-.094 2-2a3.828 3.828 0 015.414 0z"
          }}></path>
        </svg></a>{`Pẹlẹ o 👋🐸`}</h3>
    <p>{`By `}<a parentName="p" {...{
        "href": "https://github.com/kdavis-coqui"
      }}>{`Kelly Davis`}</a></p>
    <p>{`Serving up another cup of Coqui coffee goodness this month, brought to you
from the birthplace of coffee, Africa!`}</p>
    <p>{`This month we’re releasing six new text-to-speech models, and they’re all for
African languages. Hausa, Yoruba, Ewe, Lingala, Asante Twi, and let us not
forget Akuapem Twi. We’ve got you covered! Also, they’re all high quality models.
Take a listen to the Yoruba model in action!`}</p>
    <div align="center">
  <iframe width="560" height="315" src="https://www.youtube.com/embed/a-9KJS1L6To" frameBorder="0" allow="accelerometer;
        autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    </div>
    <p>{`Orin si eti mi! Also, we’re not only releasing the models, but also the data
we use to train these models, all under an open source license! (Don’t say
we never did anything for you!)`}</p>
    <p>{`In addition, this month we’ve a new 🐸TTS release, 🐸TTS v0.6.2, with new
models and lots of little bug fixes and enhancements. Also, we are bringing
back the community spotlight, this time we’re shining it on
`}<a parentName="p" {...{
        "href": "https://github.com/LordApplesause"
      }}>{`@LordApplesause`}</a>{` and the ever helpful
`}<a parentName="p" {...{
        "href": "https://github.com/p0p4k"
      }}>{`@p0p4k`}</a>{`. A tip of the hat to you!`}</p>
    <p>{`Gbadun iwe iroyin naa!🐸`}</p>
    <h3 {...{
      "id": "african-language-tts-models",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#african-language-tts-models",
        "aria-label": "african language tts models permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "16",
          "height": "16",
          "focusable": "false",
          "viewBox": "0 0 16 16"
        }}>{`
  `}<path parentName="svg" {...{
            "fill": "currentColor",
            "d": "M4.441 7.38l.095.083.939.939-.708.707-.939-.939-2 2-.132.142a2.829 2.829 0 003.99 3.99l.142-.132 2-2-.939-.939.707-.708.94.94a1 1 0 01.083 1.32l-.083.094-2 2A3.828 3.828 0 01.972 9.621l.15-.158 2-2A1 1 0 014.34 7.31l.101.07zm7.413-3.234a.5.5 0 01.057.638l-.057.07-7 7a.5.5 0 01-.765-.638l.057-.07 7-7a.5.5 0 01.708 0zm3.023-3.025a3.829 3.829 0 01.15 5.257l-.15.158-2 2a1 1 0 01-1.32.083l-.094-.083-.94-.94.708-.707.939.94 2-2 .132-.142a2.829 2.829 0 00-3.99-3.99l-.142.131-2 2 .939.939-.707.708-.94-.94a1 1 0 01-.082-1.32l.083-.094 2-2a3.828 3.828 0 015.414 0z"
          }}></path>
        </svg></a>{`African Language TTS Models`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1000px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "119.19999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,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')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "IMAGE",
          "title": "IMAGE",
          "src": "/static/16e35f99d37001c92666b86dc77095cb/da8b6/AfricanLanguageMap.png",
          "srcSet": ["/static/16e35f99d37001c92666b86dc77095cb/43fa5/AfricanLanguageMap.png 250w", "/static/16e35f99d37001c92666b86dc77095cb/c6e3d/AfricanLanguageMap.png 500w", "/static/16e35f99d37001c92666b86dc77095cb/da8b6/AfricanLanguageMap.png 1000w"],
          "sizes": "(max-width: 1000px) 100vw, 1000px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`By `}<a parentName="p" {...{
        "href": "https://github.com/JRMeyer"
      }}>{`Josh Meyer`}</a></p>
    <p>{`If you already starred the TTS repo on Github, you probably noticed the v0.6.2 release
of TTS…but maybe you didn’t see the BIG news buried in the release notes 😎 We
recently released six (6) new state-of-the-art TTS models for six languages spoken on
the African continent!`}</p>
    <p>{`The six new languages and models are:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Model`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Language`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Example Greeting`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`hau/openbible/vits`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://en.wikipedia.org/wiki/Hausa_language"
            }}>{`Hausa`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Salama alaikum!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yor/openbible/vits`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://en.wikipedia.org/wiki/Yoruba_language"
            }}>{`Yoruba`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ẹ n lẹ!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ewe/openbible/vits`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://en.wikipedia.org/wiki/Ewe_language"
            }}>{`Ewe`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nkekea nenyo!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`lin/openbible/vits`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://en.wikipedia.org/wiki/lingala_language"
            }}>{`Lingala`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boyei bolamu!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`tw_asante/openbible/vits`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://en.wikipedia.org/wiki/Asante_dialect"
            }}>{`Asante Twi`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Me ma wo akye!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`tw_akuapem/openbible/vits`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://en.wikipedia.org/wiki/Akuapem_dialect"
            }}>{`Akuapem Twi`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mpɔ mu te sεn?`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Go check out the models for yourself on our
`}<a parentName="p" {...{
        "href": "https://huggingface.co/spaces/coqui/CoquiTTS"
      }}>{`official Huggingface Spaces`}</a>{` page!`}</p>
    <p>{`These languages are collectively spoken by millions and millions of people everyday!`}</p>
    <p>{`These models are special for a few reasons. They are:`}</p>
    <ul>
      <li parentName="ul">{`✅Result of our first ever collaboration with the excellent `}<a parentName="li" {...{
          "href": "https://www.masakhane.io/"
        }}>{`Masakhane`}</a>{` group`}</li>
      <li parentName="ul">{`✅First ever African languages released in 🐸TTS`}</li>
      <li parentName="ul">{`✅New State-of-the-Art synthetic voices in all six languages`}</li>
      <li parentName="ul">{`✅Released under a commercial friendly Creative Common license`}</li>
    </ul>
    <p>{`The successful training of these models further goes to show how linguistically flexible
🐸TTS really is. We used an efficient training trick to get these models trained fast: we
taught one of our English models to speak each of these languages. We used a kind of
“cross-lingual transfer-learning” to “fine-tune” an American English woman’s voice to
sound like a man speaking Yoruba (for example) and it saved us a huge amount of time.
Another example of 🐸TTS learning a new language fast!`}</p>
    <p>{`Even if you don’t speak these languages, you can appreciate the quality of the TTS models.
Here’s the Yoruba model reading a paragraph on food:`}</p>
    <div align="center">
  <iframe width="560" height="315" src="https://www.youtube.com/embed/a-9KJS1L6To" frameBorder="0" allow="accelerometer;
        autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    </div>
    <h3 {...{
      "id": "african-languages-dataset",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#african-languages-dataset",
        "aria-label": "african languages dataset permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "16",
          "height": "16",
          "focusable": "false",
          "viewBox": "0 0 16 16"
        }}>{`
  `}<path parentName="svg" {...{
            "fill": "currentColor",
            "d": "M4.441 7.38l.095.083.939.939-.708.707-.939-.939-2 2-.132.142a2.829 2.829 0 003.99 3.99l.142-.132 2-2-.939-.939.707-.708.94.94a1 1 0 01.083 1.32l-.083.094-2 2A3.828 3.828 0 01.972 9.621l.15-.158 2-2A1 1 0 014.34 7.31l.101.07zm7.413-3.234a.5.5 0 01.057.638l-.057.07-7 7a.5.5 0 01-.765-.638l.057-.07 7-7a.5.5 0 01.708 0zm3.023-3.025a3.829 3.829 0 01.15 5.257l-.15.158-2 2a1 1 0 01-1.32.083l-.094-.083-.94-.94.708-.707.939.94 2-2 .132-.142a2.829 2.829 0 00-3.99-3.99l-.142.131-2 2 .939.939-.707.708-.94-.94a1 1 0 01-.082-1.32l.083-.094 2-2a3.828 3.828 0 015.414 0z"
          }}></path>
        </svg></a>{`African Languages Dataset`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1000px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "114.00000000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAAXABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMGBf/EABkBAAEFAAAAAAAAAAAAAAAAAAIAAQMFBv/aAAwDAQACEAMQAAAB3k45zL3G0TTjXiDD2wS//8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIABAMREiH/2gAIAQEAAQUCbNuYbSuXA3koYnitywXUBHVelzY8n//EABcRAAMBAAAAAAAAAAAAAAAAAAACERD/2gAIAQMBAT8Bql3/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIQ/9oACAECAQE/AdLliQef/8QAIRAAAgEDAwUAAAAAAAAAAAAAAAERAjFBEBMhIlFhcYH/2gAIAQEABj8C4aPFjA4cP2LssFz4VVVRtz06f//EABwQAQEBAAMAAwAAAAAAAAAAAAERACExQVFhkf/aAAgBAQABPyEeJiebwhVXL0Zc5wEA5i80jWIRDvAJ9M7lBo7vxlvs/N//2gAMAwEAAgADAAAAEJwYvv/EABgRAQEBAQEAAAAAAAAAAAAAAAEAIRFh/9oACAEDAQE/EBscvEnSG//EABcRAQEBAQAAAAAAAAAAAAAAAAERACH/2gAIAQIBAT8QrltyU7ol03//xAAdEAEAAgEFAQAAAAAAAAAAAAABABExIUFRYcGR/9oACAEBAAE/EG3dshWt5cmjYFa1o5xLxeHHcS0O34a/IkEBBUUabeoLT8vnUq1oBtyYtJyGXBNg8jHeTlP/2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "IMAGE",
          "title": "IMAGE",
          "src": "/static/c8abb7e60f7b1455b55904be18d04d8b/dbdff/OldAfricanLanguageMap.jpg",
          "srcSet": ["/static/c8abb7e60f7b1455b55904be18d04d8b/0988f/OldAfricanLanguageMap.jpg 250w", "/static/c8abb7e60f7b1455b55904be18d04d8b/d1f95/OldAfricanLanguageMap.jpg 500w", "/static/c8abb7e60f7b1455b55904be18d04d8b/dbdff/OldAfricanLanguageMap.jpg 1000w"],
          "sizes": "(max-width: 1000px) 100vw, 1000px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`By `}<a parentName="p" {...{
        "href": "https://github.com/JRMeyer"
      }}>{`Josh Meyer`}</a></p>
    <p>{`In the above section we told you about the new high-quality African models we
just released with 🐸TTS. What you don’t know yet is that we’ve been collaborating
with excellent researchers from Africa and all over the world to build the dataset
used to train those new voices.`}</p>
    <p>{`As you might know, data is the life-blood of deep learning. These shockingly
realistic synthetic voices wouldn’t have been possible without a shockingly
high-quality dataset. Collaborating with Masakhane and researchers from
Carnegie Mellon, Johns Hopkins, Saarland University, and elsewhere, we created
that dataset, and we’re releasing it to the world under a commercial friendly,
Creative Commons license. All the juicy details on how we created the dataset
and trained the models are slated to come out at INTERSPEECH 2022
(a top-tier research conference for speech technologies). Until then, you can
read more on our `}<a parentName="p" {...{
        "href": "/blog/tts/african-languages-dataset-collaboration"
      }}>{`blogpost`}</a>{`!`}</p>
    <h3 {...{
      "id": "tts-v062",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#tts-v062",
        "aria-label": "tts v062 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "16",
          "height": "16",
          "focusable": "false",
          "viewBox": "0 0 16 16"
        }}>{`
  `}<path parentName="svg" {...{
            "fill": "currentColor",
            "d": "M4.441 7.38l.095.083.939.939-.708.707-.939-.939-2 2-.132.142a2.829 2.829 0 003.99 3.99l.142-.132 2-2-.939-.939.707-.708.94.94a1 1 0 01.083 1.32l-.083.094-2 2A3.828 3.828 0 01.972 9.621l.15-.158 2-2A1 1 0 014.34 7.31l.101.07zm7.413-3.234a.5.5 0 01.057.638l-.057.07-7 7a.5.5 0 01-.765-.638l.057-.07 7-7a.5.5 0 01.708 0zm3.023-3.025a3.829 3.829 0 01.15 5.257l-.15.158-2 2a1 1 0 01-1.32.083l-.094-.083-.94-.94.708-.707.939.94 2-2 .132-.142a2.829 2.829 0 00-3.99-3.99l-.142.131-2 2 .939.939-.707.708-.94-.94a1 1 0 01-.082-1.32l.083-.094 2-2a3.828 3.828 0 015.414 0z"
          }}></path>
        </svg></a>{`🐸TTS v0.6.2`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1000px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "72%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAAOABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQGAQP/xAAWAQEBAQAAAAAAAAAAAAAAAAAGBAX/2gAMAwEAAhADEAAAAX1ucmRTVxhLqf/EABkQAAMBAQEAAAAAAAAAAAAAAAMEBQIBIv/aAAgBAQABBQLPOMGVXC1o/glXpVk5Vgm7z9Pax//EABwRAAICAgMAAAAAAAAAAAAAAAECACESMSJR8P/aAAgBAwEBPwFODqrDHdDXqhJ7n//EAB4RAQABAwUBAAAAAAAAAAAAAAECAAMREiFBYbHh/9oACAECAQE/AWI2pysuQxvz37RqT61//8QAIhAAAgEEAgEFAAAAAAAAAAAAAQIDABESIQQxIiNBUWJx/9oACAEBAAY/ArxZABdtPpVH52aCxWSaLd3Hi9/kURLxuRl9DkKl5gl3Enpi3RrBjksyBDlWAQde1f/EAB4QAQEAAgICAwAAAAAAAAAAAAERACExUWFxkaHB/9oACAEBAAE/IdgmzaraPZ9GQJACHkHZe8kR+FPwn7vESWgGoyvq4dQxwLZb85JjBy1n/9oADAMBAAIAAwAAABC4/wD/xAAaEQEAAgMBAAAAAAAAAAAAAAABETEAUWGB/9oACAEDAQE/EGhqpBZIXvG3wTDn/8QAGxEBAAICAwAAAAAAAAAAAAAAAREhAIExcfD/2gAIAQIBAT8Qt8xKbAwvkjpW1ETxtz//xAAdEAEBAAMBAAMBAAAAAAAAAAABEQAhMUFhcYGR/9oACAEBAAE/EOPe1WRKjODEa3JPcYFeVAEOhBKMQQrykpBca06APcRkiFCLNGH5b9YR6aKQA4EP8+cWkFIu2xdl3L+5/9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "IMAGE",
          "title": "IMAGE",
          "src": "/static/1e77dc6fce06f5a577ab0e4d0674e779/dbdff/release.jpg",
          "srcSet": ["/static/1e77dc6fce06f5a577ab0e4d0674e779/0988f/release.jpg 250w", "/static/1e77dc6fce06f5a577ab0e4d0674e779/d1f95/release.jpg 500w", "/static/1e77dc6fce06f5a577ab0e4d0674e779/dbdff/release.jpg 1000w"],
          "sizes": "(max-width: 1000px) 100vw, 1000px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`By `}<a parentName="p" {...{
        "href": "https://github.com/erogol"
      }}>{`Eren Gölge`}</a></p>
    <p>{`This minor release has significant bug fixes and improvements. Most importantly,
it is accompanied by 6 new TTS models in various African languages that you
can try right now under 🐸TTS.`}</p>
    <p>{`This is also our first release with our new team members @Coqui; Edresson
Cassanova, Julian Weber, and Logan Harth. We welcome them once again, and
cheers for all the success we’ll have together 😄.`}</p>
    <p>{`You can also check the `}<a parentName="p" {...{
        "href": "https://github.com/coqui-ai/TTS/releases"
      }}>{`release notes`}</a>{`
to learn more about v0.6.2`}</p>
    <h3 {...{
      "id": "community-spotlight-lordapplesause-and-p0p4k",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#community-spotlight-lordapplesause-and-p0p4k",
        "aria-label": "community spotlight lordapplesause and p0p4k permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "16",
          "height": "16",
          "focusable": "false",
          "viewBox": "0 0 16 16"
        }}>{`
  `}<path parentName="svg" {...{
            "fill": "currentColor",
            "d": "M4.441 7.38l.095.083.939.939-.708.707-.939-.939-2 2-.132.142a2.829 2.829 0 003.99 3.99l.142-.132 2-2-.939-.939.707-.708.94.94a1 1 0 01.083 1.32l-.083.094-2 2A3.828 3.828 0 01.972 9.621l.15-.158 2-2A1 1 0 014.34 7.31l.101.07zm7.413-3.234a.5.5 0 01.057.638l-.057.07-7 7a.5.5 0 01-.765-.638l.057-.07 7-7a.5.5 0 01.708 0zm3.023-3.025a3.829 3.829 0 01.15 5.257l-.15.158-2 2a1 1 0 01-1.32.083l-.094-.083-.94-.94.708-.707.939.94 2-2 .132-.142a2.829 2.829 0 00-3.99-3.99l-.142.131-2 2 .939.939-.707.708-.94-.94a1 1 0 01-.082-1.32l.083-.094 2-2a3.828 3.828 0 015.414 0z"
          }}></path>
        </svg></a>{`Community Spotlight: LordApplesause and p0p4k`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1000px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "150%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAUGBAP/xAAWAQEBAQAAAAAAAAAAAAAAAAAFBgT/2gAMAwEAAhADEAAAAZ2nQ7dCFydhaBjWsDrKta8Qih3/xAAbEAACAwEBAQAAAAAAAAAAAAACAwQFBgESE//aAAgBAQABBQIH8rpEbSkqE5S3npY/hBB1ldmnE+pjwHy3UBg7lPPilW6WxaAZm5Nb5mL+r//EACQRAAEDAgQHAAAAAAAAAAAAAAECBBEAAxIhIvAFExQxQmGh/9oACAEDAQE/AXlzqkKZNRhKfHIZbiuVi1YqYN0uLK39oaiIVP2N9qVwNsoyi9A9g1//xAAdEQABBAMBAQAAAAAAAAAAAAABAAIREgMhQQQT/9oACAECAQE/AZY6vof3u0X0NYTMeRppkIgHUL6u6F//xAAlEAACAQQBBAEFAAAAAAAAAAABAgMABBExEhMhIkFCUVJhcdH/2gAIAQEABj8CV5cjY1nNNOtqWQvx3XUMaHl3Bx6qJsl5mfxBPbH6praONYZoE4svxf8ANRmbYJVc/SpL24YGGEsIlY6Gd091L4LLlhz+3Q/tQhbhF45BDnHuhZI5WJsFgPdLYz5mtnHBEOlpntp+jEfgwziv/8QAHxAAAgICAgMBAAAAAAAAAAAAAREAITFhUXFBgcGh/9oACAEBAAE/IRYKKLkyIIKNjxya8DmUQcKSywXAvlvJRN7V+wVogbQWV7v3M+aGa0Poi8CEkF0AG4ThEWlRQ9P2htODdAt8U5LHAnnVYhDanhL0cgwYysuN0Xif/9oADAMBAAIAAwAAABC4JfP/xAAcEQEBAAIDAQEAAAAAAAAAAAABESFBADGBUWH/2gAIAQMBAT8QQuykShq+FQDO057mdb9415RR1WqvkCfgM2p7XoUh8UwptMPP/8QAHxEBAAIBAwUAAAAAAAAAAAAAAREhQQAxcVFhgZGx/9oACAECAQE/ECdpaNkY+5ZrA6kFOK9eNbqiERRsPdb56jBns5Nf/8QAGxABAAIDAQEAAAAAAAAAAAAAAREhADFRQWH/2gAIAQEAAT8QKwPhIEBzy9FZaJE+OIUCSmBYvIquEWSQhYiXggWk4zEC0J5pMzW5ypBxOEMnQmsi5YqJPsNggPAwNgXrEIwALNlvwwPYSgypXhvdXMElkYd9OxSH7lUUHEaAW4gX071lmnHIVRoFIjMebTFo5GSCyAOImzXmf//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "IMAGE",
          "title": "IMAGE",
          "src": "/static/331248738385fef074659bc5b10c52f8/dbdff/community.jpg",
          "srcSet": ["/static/331248738385fef074659bc5b10c52f8/0988f/community.jpg 250w", "/static/331248738385fef074659bc5b10c52f8/d1f95/community.jpg 500w", "/static/331248738385fef074659bc5b10c52f8/dbdff/community.jpg 1000w"],
          "sizes": "(max-width: 1000px) 100vw, 1000px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`By `}<a parentName="p" {...{
        "href": "https://github.com/erogol"
      }}>{`Eren Gölge`}</a></p>
    <p>{`This month we wanted to shine our spotlight on
`}<a parentName="p" {...{
        "href": "https://github.com/LordApplesause"
      }}>{`@LordApplesause`}</a>{` and
`}<a parentName="p" {...{
        "href": "https://github.com/p0p4k"
      }}>{`@p0p4k`}</a>{`.`}</p>
    <p>{`@LordApplesause created a great `}<a parentName="p" {...{
        "href": "https://lordoapple.medium.com/cloning-your-voice-cb321908b060"
      }}>{`blog post`}</a>{`
that gets you quickly up to speed on using 🐸TTS to train your own text-to-speech
model using the Colab.`}</p>
    <p>{`@p0p4k has been our most active members of the 🐸TTS
`}<a parentName="p" {...{
        "href": "https://github.com/coqui-ai/TTS/discussions"
      }}>{`discussions`}</a>{` forum. Beyond the
forum, he’s also expanding everyone’s horizons with reviews of two important
papers `}<a parentName="p" {...{
        "href": "https://github.com/coqui-ai/TTS/discussions/1506"
      }}>{`Conditional Variational Autoencoder with Adversarial Learning for
End-to-End Text-to-Speech`}</a>{` and
`}<a parentName="p" {...{
        "href": "https://github.com/coqui-ai/TTS/discussions/1494"
      }}>{`Glow-TTS: A Generative Flow for Text-to-Speech via Monotonic Alignment Search`}</a>{`);
reviews that were a pleasure to read.`}</p>
    <p>{`Let us know if you’ve done something cool😎 with our open-source projects
and you could get a “shout out” here along with some of our cool😎 swag.`}</p>
    {
      /* markdownlint-enable line-length */
    }


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      